export default __webpack_public_path__ + "static/media/gallery_07.956b8e2a.jpg";